export const OPEN = "@@window/OPEN";
export const REPLACE = "@@window/REPLACE";
export const REPLACE_FAILED = "@@window/REPLACE_FAILED";
export const CHANGE_PRIORITY = "@@window/CHANGE_PRIORITY";
export const CHANGE_PRIORITY_FAILED = "@@window/CHANGE_PRIORITY_FAILED";
export const TOGGLE_MINIMALIZE = "@@window/TOGGLE_MINIMALIZE";
export const RENAME = "@@window/RENAME";
export const CHANGE_PROP_FAILED = "@@widnow/CHANGE_PROP_FAILED";
export const CLOSE = "@@window/CLOSE";
export const CLOSE_FAILED = "@@window/CLOSE_FAILED";
export const CLOSE_ALL = "@@window/CLOSE_ALL";
export const REMOVE_FOCUS = "@@window/REMOVE_FOCUS";
